import { atom } from "jotai";

// Webhook event types
export const WEBHOOK_EVENT_TYPES = {
    ORDER_CREATED: "order.created",
    BOOKING_CREATED: "booking.created",
    BOOKING_UPDATED: "booking.updated",
    CLIENT_CREATED: "client.created",
    CLIENT_UPDATED: "client.updated",
    /* CLIENT_DELETED: "client.deleted", */
    WAITLIST_CREATED: "waitlist.created"
};

export const WEBHOOK_EVENT_TYPE_LABELS = {
    [WEBHOOK_EVENT_TYPES.ORDER_CREATED]: "Order Created",
    [WEBHOOK_EVENT_TYPES.BOOKING_CREATED]: "Booking Created",
    [WEBHOOK_EVENT_TYPES.BOOKING_UPDATED]: "Booking Updated",
    [WEBHOOK_EVENT_TYPES.CLIENT_CREATED]: "Client Created",
    [WEBHOOK_EVENT_TYPES.CLIENT_UPDATED]: "Client Updated",
    /*  [WEBHOOK_EVENT_TYPES.CLIENT_DELETED]: "Client Deleted", */
    [WEBHOOK_EVENT_TYPES.WAITLIST_CREATED]: "Waitlist Created"
};

// Array of event types for filter dropdown
export const WEBHOOK_EVENT_TYPE_OPTIONS = Object.entries(
    WEBHOOK_EVENT_TYPE_LABELS
).map(([value, label]) => ({ value, label }));

export const WEBHOOK_STATUS = {
    ACTIVE: "active",
    INACTIVE: "inactive"
};

export const WEBHOOK_STATUS_OPTIONS = [
    { value: "all", label: "All" },
    { value: "active", label: "Published" },
    { value: "inactive", label: "Unpublished" }
];

// Pagination config
export const webhooksPaginationAtom = atom({ page: 0, perPage: 25 });

export const setWebhooksPageAtom = atom(null, (_get, set, page) => {
    set(webhooksPaginationAtom, (prev) => ({ ...prev, page }));
});

export const setWebhooksPerPageAtom = atom(null, (_get, set, perPage) => {
    set(webhooksPaginationAtom, (prev) => ({ ...prev, perPage, page: 0 }));
});

// Search and filter state
export const webhooksSearchAtom = atom("");
export const webhooksEventTypeFilterAtom = atom([]); // Empty array = all event types
export const webhooksStatusFilterAtom = atom("all"); // "all", "active", or "inactive"

// Sorting state - default: status desc (active first), then eventType asc, then createdAt desc
export const webhooksSortAtom = atom({
    orderBy: "status",
    order: "desc" // desc for status means active first
});

// Modal states
export const openAddWebhookModalAtom = atom(false);
export const openViewWebhookModalAtom = atom(false);
export const selectedWebhookAtom = atom(null);
